import cn from 'classnames';

import './Spinner.scss';
import styles from './Spinner.module.scss';

const ITEMS_NUMBER = 12;
const itemsClasses: string[] = [];
const subItemsClasses: string[] = [];

for (let i = 0, len = ITEMS_NUMBER; i < len; i += 1) {
  itemsClasses.push(cn(styles.Item, styles[`Item${i + 1}`]));
  subItemsClasses.push(cn(styles.SubItem, styles[`SubItem${i + 1}`]));
}

interface ISpinnerProps {
  className?: string;
}

export const Spinner = ({ className }: ISpinnerProps) => {
  return (
    <div className={cn(styles.Container, className)} role="progressbar" hidden>
      <div className={styles.Body}>
        {itemsClasses.map((itemClass, index) => (
          <div className={itemClass} key={index}>
            <div className={subItemsClasses[index]} />
          </div>
        ))}
      </div>
    </div>
  );
};
